import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PhoneNumberDirective } from './phone-number.directive';

@NgModule({
	declarations: [PhoneNumberDirective],
	exports: [PhoneNumberDirective],
	imports: [CommonModule],
})
export class PhoneNumberModule {}
